import React from "react";
import { useTranslation } from "react-i18next";
import MyTeamPayrollOutputReportLayout from "./MyTeamPayrollOutputLayout";
import { CalendarSymbol } from "../../../../assets/icons";
import { MyTeamPayrollOutputSummaryDTO } from "../../../../models/my-team-payroll-output-summary/my-team-payroll-output-summary-dto";

const MyTeamPayrollRunLink = ({
  customSummary,
  loading,
}: {
  customSummary: MyTeamPayrollOutputSummaryDTO;
  loading: boolean;
}) => {
  const { t } = useTranslation();
  const tRP = "components.custom_widget_links.my_team_payroll_output";

  const monthsList = [
    t("months.january"),
    t("months.february"),
    t("months.march"),
    t("months.april"),
    t("months.may"),
    t("months.june"),
    t("months.july"),
    t("months.august"),
    t("months.september"),
    t("months.october"),
    t("months.november"),
    t("months.december"),
  ];

  const nextRunDate = customSummary?.nextRun;

  let date = "-";

  if (nextRunDate && new Date(nextRunDate)?.getFullYear() > 1900) {
    const month = new Date(nextRunDate).getMonth();
    const day =
      new Date(nextRunDate).getDate() < 10 ? `0${new Date(nextRunDate).getDate()}` : new Date(nextRunDate).getDate();

    date = `${monthsList[month]} ${day}`;
  }

  return (
    <>
      <MyTeamPayrollOutputReportLayout
        date={date}
        loading={loading}
        linkName={`${t(`${tRP}.see_calendar`)}`}
        textForDate={`${t(`${tRP}.next_run`)}:`}
        Icon={CalendarSymbol}
      />
    </>
  );
};
export default MyTeamPayrollRunLink;
